import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconVideo"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.75C2 5.23122 3.23122 4 4.75 4H13.25C14.7688 4 16 5.23122 16 6.75V8.78691L19.4674 7.05322C20.631 6.47143 22 7.31755 22 8.61847V15.3824C22 16.6833 20.631 17.5294 19.4674 16.9476L16 15.214V17.25C16 18.7688 14.7688 20 13.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75ZM16 13.5369L20.1382 15.606C20.3044 15.6891 20.5 15.5682 20.5 15.3824V8.61847C20.5 8.43262 20.3044 8.31175 20.1382 8.39486L16 10.464V13.5369Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo;
